import "./bootstrap-public.js";
import { createApp } from "vue";
import { createPinia } from "pinia";
import "@helpers/Forms/validationRules.js";


import AOS from "aos";
import "aos/dist/aos.css";

// Forms
import FormBuilder from "@components/Public/Forms/FormBuilder.vue";

// Toggler for modals and sidebars
import Toggler from "@components/Public/Toggler.vue";

// Modal
import Modal from "@components/Public/Modal.vue";

// Sidebar
import Sidebar from "@components/Public/Sidebar.vue";

// Calculators
import HomeLoanCalculator from "@components/Public/Calculators/HomeLoanCalculator.vue";


// Popup Manager
//import PopupManager from "@components/Public/PopupManager.vue";

// Shop
// import Product from "@components/Public/Shop/Product/Product.vue";
// import Cart from "@components/Public/Shop/Cart/Cart.vue";
// import CartSummary from "@components/Public/Shop/Cart/CartSummary.vue";
// import Checkout from "@components/Public/Shop/Checkout/Checkout.vue";
// import FloatingCart from "@components/Public/Shop/Components/FloatingCart.vue";

const app = createApp({});

// Register Pinia
app.use(createPinia());

// Register components
app.component("form-builder", FormBuilder);
app.component("modal", Modal);
app.component("sidebar", Sidebar);
app.component("toggler", Toggler); // What opens modals and sidebars
app.component("home-loan-calculator", HomeLoanCalculator);
//app.component("popup-manager", PopupManager);
// app.component("product", Product);
// app.component("checkout", Checkout);
// app.component("cart", Cart);
// app.component("cart-summary", CartSummary);
// app.component("floating-cart", FloatingCart);

app.mount("#app");

// AOS Initialization
AOS.init({
    offset: 100,
    delay: 50,
    duration: 600,
    easing: "ease-in-out",
    once: true,
});